export const SET_TRANSLATIONS = 'SET_TRANSLATIONS';
export type SET_TRANSLATIONS = typeof SET_TRANSLATIONS;
